
import { createElement, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { join, isNullOrEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, comparePrimitives, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { MultipleImageUploadDialog, ImageUploadDialog } from "./ImageUploadDialog.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ImageViewer } from "../../Components/ImageViewer.js";
import { filter, sortBy, map, tryFind, ofArray, singleton as singleton_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TextButton } from "../../Components/Button.js";

export function ImageWidget(props) {
    let elems_1;
    const patternInput = useTranslation();
    const getImage = (_arg) => {
        if (isNullOrEmpty(props.ImageUrl)) {
            return undefined;
        }
        else {
            return props.ImageUrl;
        }
    };
    const patternInput_1 = useState(getImage());
    const imageUrl = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsImageViewerOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsDialogOpen = patternInput_3[1];
    const dependencies = [props.ImageUrl];
    reactApi.useEffect(() => {
        setIsDialogOpen(false);
        patternInput_1[1](getImage);
    }, dependencies);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "w-96", "max-w-full"])], (elems_1 = toList(delay(() => append(singleton(createElement(ImageUploadDialog, {
        FormState: props.FormState,
        ImageUrl: unwrap(imageUrl),
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsDialogOpen(false);
        },
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
    })), delay(() => {
        let matchValue, imageUrl_1;
        return append((matchValue = imageUrl, (matchValue != null) ? ((imageUrl_1 = matchValue, append(singleton(reactElement("img", {
            "data-test-id": "img-viewer-preview",
            className: join(" ", ["cursor-pointer", "h-64", "object-cover"]),
            src: imageUrl_1,
            onClick: (_arg_4) => {
                setIsImageViewerOpen(true);
            },
        })), delay(() => singleton(ImageViewer({
            Images: singleton_1({
                Src: props.ImageUrl,
            }),
            IsOpen: patternInput_2[0],
            OnClose: () => {
                setIsImageViewerOpen(false);
            },
        })))))) : singleton(reactElement("img", {
            "data-test-id": "img-viewer-preview-empty",
            className: join(" ", ["h-64", "object-cover"]),
            src: "/assets/images/placeholder-image-light.png",
            onClick: (_arg_3) => {
                setIsImageViewerOpen(true);
            },
        }))), delay(() => {
            let elems;
            return props.CanEditImage ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems = [createElement(TextButton, {
                ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                Label: patternInput[0]("general.image_action"),
                OnClick: () => {
                    setIsDialogOpen(true);
                },
                TestId: "picture-upload-button",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function MultipleImageWidget(props) {
    let elems_2;
    const patternInput = useTranslation();
    const mainImage = tryFind((image) => (image.Position === 1), props.Images);
    const patternInput_1 = reactApi.useState(undefined);
    const setImageViewerActiveIndex = patternInput_1[1];
    const imageViewerActiveIndex = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsDialogOpen = patternInput_2[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "w-96", "max-w-full"])], (elems_2 = toList(delay(() => append(singleton(createElement(MultipleImageUploadDialog, {
        ComponentState: props.ComponentState,
        Images: props.FormImages,
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsDialogOpen(false);
        },
        OnSave: () => {
            props.OnSave();
            setIsDialogOpen(false);
        },
        SetImages: props.OnImagesChanged,
    })), delay(() => append(singleton(ImageViewer({
        ActiveIndex: unwrap(imageViewerActiveIndex),
        Images: map((image_1) => ({
            Src: image_1.ImageUrl,
        }), sortBy((_arg_2) => (_arg_2.Position | 0), props.Images, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })),
        IsOpen: imageViewerActiveIndex != null,
        OnClose: () => {
            setImageViewerActiveIndex(undefined);
        },
    })), delay(() => {
        let matchValue, image_2;
        return append((matchValue = mainImage, (matchValue != null) ? ((image_2 = matchValue, singleton(reactElement("img", {
            "data-test-id": "img-viewer-preview",
            className: join(" ", ["cursor-pointer", "h-64", "object-cover"]),
            src: image_2.ImageUrl,
            onClick: (_arg_5) => {
                setImageViewerActiveIndex(0);
            },
        })))) : singleton(reactElement("img", {
            "data-test-id": "img-viewer-preview-empty",
            className: join(" ", ["h-64", "object-cover"]),
            src: "/assets/images/placeholder-image-light.png",
            onClick: (_arg_4) => {
                setImageViewerActiveIndex(undefined);
            },
        }))), delay(() => {
            let elems;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2", "pt-3"])], (elems = toList(delay(() => map((image_4) => reactElement("img", {
                className: join(" ", ["cursor-pointer", "h-20", "w-20", "object-cover", int32ToString(image_4.Position)]),
                src: image_4.ImageUrl,
                onClick: (_arg_7) => {
                    setImageViewerActiveIndex(image_4.Position - 1);
                },
            }), sortBy((_arg_6) => (_arg_6.Position | 0), filter((image_3) => (image_3.Position !== 1), props.Images), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let elems_1;
                return props.CanEditImage ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = [createElement(TextButton, {
                    ComponentState: props.ComponentState,
                    Label: patternInput[0]("general.image_action"),
                    OnClick: () => {
                        setIsDialogOpen(true);
                    },
                    TestId: "picture-upload-button",
                    Variant: "blueButton",
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

